import moment from 'moment'
import { computed, unref, MaybeRef } from 'vue'

type DateLike = Date | number | string | undefined | null

/**
 * Display date in format
 */
export default function useDate(date: MaybeRef<DateLike>, format: string = 'MMM DD, YYYY') {
  const dateComp = computed<string>(() => {
    const d = unref(date)
    // @ts-ignore
    return moment(d).format(format)
  })

  const isValid = computed(() => {
    const d = unref(date)
    // @ts-ignore
    return moment(d).isValid()
  })

  return { date: dateComp, isValid }
}
